import React from "react";

import { LogoMarqueeBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import styles from "./LogoMarquee.module.scss";

export const LogoMarquee = ({ value }: { value: LogoMarqueeBlock }) => {
    const logos = value.logos ?? [];
    if (logos.length === 0) return null;

    const renderLogos = (prefix: string) =>
        logos.map((logo, i) => (
            <div key={`${prefix}-${i}`} className={styles.logoItem}>
                <ImageChooserBlock
                    value={logo}
                    useImageData={false}
                    imageAttrs={{
                        loading: "eager",
                        decoding: "async",
                        width: logo.width,
                        height: logo.height,
                    }}
                />
            </div>
        ));

    return (
        <div className={styles.root}>
            {value.eyebrow && <p className={styles.eyebrow}>{value.eyebrow}</p>}
            <div className={styles.track} aria-hidden="true">
                <div className={styles.scroll}>
                    {renderLogos("a")}
                    {/* Duplicate for seamless infinite loop */}
                    {renderLogos("b")}
                </div>
            </div>
        </div>
    );
};
